export enum Trainings {
  NoTrainingsCompleted = 4
}
